import { all, put, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { REQUEST_MONITOR_OVERALL_STATS } from './types';

import { monitorOverallStatsSuccess, monitorOverallStatsFailure } from './reducer';

const logger = new Logger('Saga:Monitor:OverallStats');

export function* getMonitorOverallStats(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const { entityId } = action;

  try {
    const response = yield authApiService.get(
      routerService.generate('api.monitor.overall_stats', { entityId }),
    );
    logger.info('Got monitor overall stats data');
    yield put(monitorOverallStatsSuccess(response.data));
  } catch (error) {
    logger.error(error);
    yield put(monitorOverallStatsFailure(error));
  }
}

export default function* userSaga() {
  return yield all([takeLatest(REQUEST_MONITOR_OVERALL_STATS, getMonitorOverallStats)]);
}
